/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GermanLegacyEssayProjector } from './germanLegacyEssayProjector';
import type { GermanLegacyOralProjector } from './germanLegacyOralProjector';
import type { BinaryPassFailProjector } from './binaryPassFailProjector';
import type { GermanBandedProjector } from './germanBandedProjector';

export type TenantPublicGradingSettingsTaskGradeProjectorsAnyOf = {
  [key: string]:
    | GermanLegacyEssayProjector
    | GermanLegacyOralProjector
    | BinaryPassFailProjector
    | GermanBandedProjector;
};
